import React, { useState, useEffect } from 'react';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import { UploaderLoader } from 'components/shared/UniversalUploader/UploaderLoader';
import ContentError from 'components/shared/UniversalPlayer/ContentError';

const FilePreview = ({ uploadId, url, name }) => {
  const [loading, setLoading] = useState(!url);
  const [error, setError] = useState(null);
  const [fileName, setName] = useState(name);
  const [fileUrl, setUrl] = useState(url);

  useEffect(() => {
    if (url) return;

    request
      .get(routes.FILE_UPLOAD.BSS.FILE_INFORMATION(uploadId))
      .then(file => {
        setUrl(file.url);
        setName(file.name);
        setLoading(false);
      })
      .catch(e => {
        setError(e);
        setLoading(false);
      });
  }, [uploadId, url]);

  if (loading) return <UploaderLoader />;
  if (error || !fileUrl) {
    return <ContentError error={error?.status} />;
  }

  const alt = fileName || t('universal_uploader.image_alt');

  return (
    <div className="file-preview">
      <img src={fileUrl} alt={alt} data-testid="uploaderPreviewImg" />
    </div>
  );
};

export default FilePreview;
